module.exports = __webpack_public_path__ + "static/media/view2.8a4173b5.jpg";